import ax from './axios';
import { formDataFromParams } from './utils';

export const getLoginInfoByEmail = (email, password) => {
  const data = { email };
  if (password) {
    data.password = password;
  }
  return ax({
    url: `/rest/auth/get-login-info-by-email/`,
    method: 'post',
    data: formDataFromParams(data),
    config: { headers: { 'Content-Type': 'multipart/form-data' } },
  });
};

export const getSignUpContext = () => {
  return ax({
    url: `/rest/auth/get-signup-context/`,
    method: 'get',
    config: { headers: { 'Content-Type': 'application/json' } },
  });
};

export const signUp = (data, cancelToken) => {
  return ax({
    url: `/rest/auth/sign-up/`,
    method: 'post',
    data: formDataFromParams(data),
    config: { headers: { 'Content-Type': 'application/json' } },
    cancelToken,
  });
};

// Tells the backend that the user failed or abandoned 3DS authentication
export const signUpAbort = (clientSecret) => {
  return ax({
    url: `/rest/auth/sign-up/abort/`,
    method: 'post',
    // Bound the request: the 3DS spinner now waits for this response to show the
    // classified decline message, so it must not hang on a dead connection.
    timeout: 15000,
    data: formDataFromParams({
      client_secret: clientSecret,
    }),
    config: { headers: { 'Content-Type': 'multipart/form-data' } },
  });
};

export const signUpPrefill = (token) => {
  return ax({
    url: `/rest/auth/sign-up/${token}/`,
    method: 'get',
    config: { headers: { 'Content-Type': 'application/json' } },
  });
};
